import React, { useRef } from "react";
import { FieldFeedback, FormValidationNotice, RequiredMark } from "../../../components/FormValidation";
import useFormValidation from "../../../hooks/useFormValidation";
import { validationRules as rule } from "../../../utils/helpers/formValidation";
import AkasSelect from "../../../components/AkasSelect";

const validationSchema = {
  type: rule.required("Flag kategori wajib dipilih."),
  value: [rule.required("Kode kategori wajib diisi."), rule.maxLength(120)],
  label: [rule.required("Label kategori wajib diisi."), rule.maxLength(120)],
  description: rule.maxLength(255),
};

const FormCategory = (props) => {
  const { isEdit, title, closeModal, formState, setFormState, isLoading, handleAdd, handleUpdate, fixedType } = props;
  const formRef = useRef(null);
  const validation = useFormValidation({ values: formState, schema: validationSchema, formId: "category", focusRoot: formRef });

  const updateField = (field, value) => {
    setFormState((previous) => ({
      ...previous,
      [field]: value,
    }));
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (!validation.validateAll()) return;
    const success = isEdit ? await handleUpdate() : await handleAdd();

    if (success !== false) {
      document.querySelector("#modal-form-category .btn-close")?.click();
    }
  };

  return (
    <div
      className="modal modal-blur fade"
      id="modal-form-category"
      tabIndex="-1"
      role="dialog"
      aria-hidden="false"
      data-bs-backdrop="static"
      data-bs-keyboard="false"
      style={{
        backgroundColor: "rgba(0, 0, 0, 0.3)",
      }}>
      <div className="modal-dialog modal-dialog-centered modal-lg" role="document">
        <form ref={formRef} className="modal-content" onSubmit={handleSubmit} noValidate>
          <div className="modal-header">
            <h5 className="modal-title">{title} {!isEdit ? "Baru" : "Edit"}</h5>
            <button
              type="button"
              className="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
              onClick={closeModal}></button>
          </div>
          <div className="modal-body">
            <FormValidationNotice errors={validation.errors} />
            <div className="row">
              {!fixedType ? (
                <div className="col-lg-12">
                  <div className="mb-3">
                    <label className="form-label">Flag Kategori<RequiredMark /></label>
                    <AkasSelect
                      {...validation.fieldProps("type")}
                      data-validation-field="type"
                      className={validation.inputClass("type", "form-select")}
                      value={formState.type}
                      required
                      onChange={(event) => updateField("type", event.target.value)}>
                      <option value="product">Produk</option>
                      <option value="material">Material</option>
                    </AkasSelect>
                    <FieldFeedback formId="category" name="type" error={validation.errors.type} hint="Penanda apakah kategori ini dipakai untuk produk atau material." />
                  </div>
                </div>
              ) : null}
              <div className="col-lg-6">
                <div className="mb-3">
                  <label className="form-label">Kode Kategori<RequiredMark /></label>
                  <input
                    {...validation.fieldProps("value")}
                    type="text"
                    className={validation.inputClass("value")}
                    placeholder="contoh: roasted beans"
                    value={formState.value}
                    maxLength={120}
                    required
                    onChange={(event) => updateField("value", event.target.value.toLowerCase())}
                  />
                  <FieldFeedback formId="category" name="value" error={validation.errors.value} hint="Maksimal 120 karakter; kode ini disimpan pada data produk/material." />
                </div>
              </div>
              <div className="col-lg-6">
                <div className="mb-3">
                  <label className="form-label">Label<RequiredMark /></label>
                  <input
                    {...validation.fieldProps("label")}
                    type="text"
                    className={validation.inputClass("label")}
                    placeholder="contoh: Roasted Beans"
                    value={formState.label}
                    maxLength={120}
                    required
                    onChange={(event) => updateField("label", event.target.value)}
                  />
                  <FieldFeedback formId="category" name="label" error={validation.errors.label} hint="Nama yang tampil kepada pengguna." />
                </div>
              </div>
              <div className="col-lg-12">
                <div className="mb-3">
                  <label className="form-label">Deskripsi<RequiredMark optional /></label>
                  <textarea
                    {...validation.fieldProps("description")}
                    className={validation.inputClass("description")}
                    rows="3"
                    placeholder="keterangan kategori"
                    value={formState.description}
                    maxLength={255}
                    onChange={(event) => updateField("description", event.target.value)}></textarea>
                  <FieldFeedback formId="category" name="description" error={validation.errors.description} hint="Maksimal 255 karakter." />
                </div>
              </div>
            </div>
          </div>
          <div className="modal-footer">
            <button type="button" className="btn btn-link link-secondary btn-3" data-bs-dismiss="modal">
              Cancel
            </button>
            {isEdit ? (
              <button type="submit" className="btn btn-primary btn-5 ms-auto" disabled={isLoading}>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  className="icon icon-tabler icons-tabler-outline icon-tabler-edit">
                  <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                  <path d="M7 7h-1a2 2 0 0 0 -2 2v9a2 2 0 0 0 2 2h9a2 2 0 0 0 2 -2v-1" />
                  <path d="M20.385 6.585a2.1 2.1 0 0 0 -2.97 -2.97l-8.415 8.385v3h3l8.385 -8.415z" />
                  <path d="M16 5l3 3" />
                </svg>
                {isLoading ? "Menyimpan..." : "Edit Data"}
              </button>
            ) : (
              <button type="submit" className="btn btn-primary btn-5 ms-auto" disabled={isLoading}>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  className="icon icon-2">
                  <path d="M12 5l0 14" />
                  <path d="M5 12l14 0" />
                </svg>
                {isLoading ? "Menyimpan..." : "Tambah Data"}
              </button>
            )}
          </div>
        </form>
      </div>
    </div>
  );
};

export default FormCategory;
